
export default {
    deadlinedateenabled: (state: any) => state.beheer?!!state.beheer.sendingenabled: false,
    deadlinedateanswerenabled: (state: any) => state.beheer?!!state.beheer.answerenabled: false,
    deadlinequestion: (state: any) => state.beheer?state.deadlinequestion:'yyyy-MM-dd',
    item: (state: any) => state.beheer.item,
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/admin/selectors.tsx